import { EventType } from './EventType';
import { startup, handlePageView, viewResource } from './handlers';
import { EventSystem } from '../utils/eventSystem';

export const Events = new EventSystem();

// Add the default event listeners.
Events.addEventListener( EventType.STARTUP, startup );
Events.addEventListener( EventType.VIEW_RESOURCE, viewResource );
Events.addEventListener( EventType.PAGE_VIEW, handlePageView );
